<template>
  <div
    v-if="mode === 'hover'"
    class="tooltip-container"
    @mouseenter="showTooltip"
    @mouseleave="delayedHideTooltip"
  >
    <slot></slot>
    <template v-if="isVisible || isForceVisible">
      <div
        class="tooltip"
        :class="direction"
        @mouseenter="showTooltipByTooltip"
        @mouseleave="hideTooltip"
      >
        <slot name="content"></slot>
      </div>
    </template>
  </div>
  <div
    v-else-if="mode === 'click'"
    class="tooltip-container"
    @click="showTooltip"
    v-click-outside="hideTooltip"
  >
    <slot></slot>
    <template v-if="isVisible || isForceVisible">
      <div class="tooltip" :class="direction">
        <slot name="content"></slot>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'BaseTooltip',
  props: {
    direction: {
      type: String,
      default: 'bottom',
    },
    mode: {
      type: String,
      default: 'hover',
    },
  },
  data() {
    return {
      isVisible: false,
      isForceVisible: false,
      message: 'This is a tooltip!',
    }
  },
  methods: {
    showTooltip() {
      this.isVisible = true
    },
    showTooltipByTooltip() {
      this.isForceVisible = true
    },
    hideTooltip() {
      this.isVisible = false
      this.isForceVisible = false
    },
    delayedHideTooltip() {
      setTimeout(() => {
        if (!this.isForceVisible) {
          this.hideTooltip()
        }
      }, 100)
    },
  },
}
</script>

<style lang="scss" scoped>
.tooltip-container {
  position: relative;
  display: inline-block;
}

.tooltip {
  position: absolute;
  padding: 16px;
  background-color: #fff;
  border-radius: 4px;
  white-space: nowrap;
  z-index: 42;
  box-shadow: 0px 2px 20px 0px rgba(0, 0, 0, 0.15);

  &.bottom {
    top: calc(100% + 5px);
    transform: translateX(-50%);
  }

  &.top {
    bottom: calc(100% + 5px);
    transform: translateX(-50%);
  }

  &.right {
    top: 0;
    left: calc(100% + 5px);
  }
}
</style>
